import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';
import SsnInputV2 from '@perpay-web/fintech/components/base/SsnInput/SsnInputV2';

const FormikSsnInput = withFormikInputWrapper(SsnInputV2);

export default FormikSsnInput;
